
import { call, put, takeEvery } from "redux-saga/effects";
import { message } from 'antd';
import taxpayer from "../Actions/taxpayer";
import user from '../Actions/user';
import { getTaxpayerVolumenRequest, generateVolumeRequest } from '../Api/Gestion';
import { startLoading, stopLoading } from '../LoadingHelper';
import { CATEGORY_GA, eventGA } from  '../Helpers/GoogleAnalytics';
const { types } = taxpayer;
const { setTaxpayerVolumeData } = taxpayer.actions;
const { getUserData } = user.actions;

export function* getTaxpayerVolumenData() {    
    const response = yield call(getTaxpayerVolumenRequest);
    try {
        if(response.status === 'success')
            yield put(setTaxpayerVolumeData(response.data));
        else
            message.error(`${response.message}`, 5);
    } catch (error) {
        message.error(`${error.message}`, 5);
    }
}

export function* generateVolume({taxId}) {
    const loadingId = yield call(startLoading,'loadingTaxpayer');
    try {    
        const response = yield call(generateVolumeRequest, taxId);
        if(response.status === 'success'){
            eventGA(CATEGORY_GA.configuration.monthlyEstimatedRequest);
            yield call(getTaxpayerVolumenData);
            message.success('Solicitud generada correctamente', 5);
        }else
            message.error(`${response.message}`, 5);
    } catch (error) {
        message.error(`${error.message}`, 5);
    } finally {		
        yield call(stopLoading, loadingId);
    }
}

export function* calculateVolumeProcess({data}) {
    const loadingId = yield call(startLoading,'loadingCertificates');
    try {
        const {taxId,query} = data;
        const response = yield call(generateVolumeRequest, taxId);
        if(response.status === 'success'){
            yield call(getTaxpayerVolumenData);
            yield put(getUserData(query));
            message.success('Solicitud generada correctamente', 5);
        }else
            message.error(`${response.message}`, 5);

    }catch(error) {
        message.error(`Ha ocurrido un error ${error.message}`, 5);
    }finally {		
        yield call(stopLoading, loadingId);
    }
}

export function* taxpayerSaga() {    
    yield takeEvery(types.GET_TAXPAYER_VOLUME_DATA, getTaxpayerVolumenData)
    yield takeEvery(types.GENERATE_VOLUME_REQUEST, generateVolume)
    yield takeEvery(types.CALCULATE_VOLUME_PROCESS, calculateVolumeProcess)
    
} 